import React from "react";
import Select from "react-select";

const RSelect = React.forwardRef((props, ref) => (
  <div className="form-control-select">
    <Select
      className={`react-select-container mw-150px ${props.className ? props.className : ""}`}
      classNamePrefix="react-select"
      menuPortalTarget={document.body}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      {...props}
      ref={ref}
    />
  </div>
));

export default RSelect;
